"use strict";

var sdHostName = 'www.sunlands.com';
var sdHostNameR = "moc.sdnalnus.www";
var sdHostNameBase = sdHostNameR.split("").reverse().join("");
var locationHArr = ['f', 'e', 'r', 'h'];
var locationH = locationHArr.reverse().join("");
var htTxtArr = ['/', '/', ':', 'p', 't', 't', 'h'];
var htTxt = htTxtArr.reverse().join("");
if (process.env.NODE_ENV == 'production' && window.location.hostname.indexOf('172') < 0 && window.location.hostname.indexOf('192') < 0 && window.location.hostname.indexOf('abctest') < 0 && window.location.hostname.indexOf('chunwan.sunlands.com') < 0) {
    if (window.location.hostname != sdHostNameBase) {
        window.location[locationH] = htTxt + sdHostNameBase;
    }
    if (sdHostName != sdHostNameBase) {
        window.location[locationH] = htTxt + sdHostNameBase;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/js/common/replaceHost.js
// module id = 15
// module chunks = 0 2 3 4 5 6 7 8 10 11 12